export const LoadingComponent = () => {
    return <div className="center-me">
        <div className="spinner-border" role="status">
            <span className="visually-hidden"></span>
        </div>
    </div>;
}
